// extracted by mini-css-extract-plugin
export var Header = "header-module--Header--169f4";
export var Header__logo = "header-module--Header__logo--793f5";
export var Header__logoLink = "header-module--Header__logo-link--5543e";
export var Header__generatorTitle = "header-module--Header__generator-title--9a312";
export var Header__nav = "header-module--Header__nav--8da37";